export default {
  state: {
    searchData: {
      type: "",
      search: "",
    },

    searchSelectData: null,
    gridFilters: {},
    actionsData: [],
    updateGrid: false,
    
  },

  getters: {
    getGridFilters(state) {
      return state.gridFilters;
    },

    getSearchData(state) {
      return state.searchData;
    },

    getSearchSelectData(state) {
      return state.searchSelectData
    },

    getActionsData(state) {
      return state.actionsData;
    },

    getUpdateGrid(state) {
      return state.updateGrid;
    },
  },

  mutations: {
    setGridFilters(state, filters) {
      state.gridFilters = filters;
    },

    setSearchData(state, data) {
      state.searchData = {
        type: data.type,
        search: data.search,
      };
    },

    setSearchSelectData(state, data) {
      state.searchSelectData = data
    },

    setActionsData(state, data) {
      state.actionsData = data;
    },

    setUpdateGridStatus(state, status) {
      state.updateGrid = status;
    },
  },

  actions: {
    changeGridFilters(context, filters) {
      context.commit("setGridFilters", filters);
    },

    changeSearchData(context, data) {
      context.commit("setSearchData", data);
    },
    
    changeSearchSelectData(context, data) {
      context.commit("setSearchSelectData", data)
    },

    changeActionsData(context, data) {
      context.commit("setActionsData", data);
    },

    changeUpdateGridStatus(context, status) {
      context.commit("setUpdateGridStatus", status);
    },
  },
};
